import { jsonApiVuex } from '@common/store/json-api-vuex';

export const tmsClientTag = jsonApiVuex(
  'tms/web-tag',
  {
    getters: {
      getTagsByContainerId: state => containerId => {
        return state.entities.filter(tag => tag.container_id == containerId);
      },
      // get the first tag that is not disabled in the container and the first tag in the container if all are disabled
      getFirstActiveOrAvailableTag: state => containerId => {
        const tags = state.entities.filter(tag => tag.container_id == containerId);
        const orderedTags = tags.sort((a, b) => (a.order < b.order ? 1 : -1));
        const firstActiveTag = orderedTags.filter(tag => !tag.disabled)[0];
        if (!firstActiveTag) {
          return orderedTags[0];
        }
        return firstActiveTag;
      },
      // need to have template and template.editor included
      getAllVendors: state => {
        const allVendors = [];
        state.entities.forEach(tag => {
          allVendors.push(tag?.template?.editor);
        });
        // remove duplicates
        return allVendors.filter((vendor, index, self) => {
          return index === self.findIndex(t => t.id === vendor.id);
        });
      },
    },
  },
  {}
);
